import { TextField } from "@mui/material"

export function RateCardAutocompleteInput(params) {
    return <TextField {...params} label="Rate Card" placeholder="Select Rate Card" />
}
